import { useEffect, useState } from "react";
import Modal from "./Modal";
import axios from "axios";
import FlexBox from "./FlexBox";
import Button from "./Button";
import theme from "../styles/theme";
import MinimalSelect from "./MinimalSelect";
import { Icon } from "@mui/material";
import styled from "styled-components";

interface Props {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  onSelect: (program: string) => void;
}

const Title = styled("div")`
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2633d4;
`;

export const ProgramSelectModal = ({ isOpen, setOpen, onSelect }: Props) => {
  const [universityOption, setUniversityOption] = useState<any[]>([]);
  const [selectedUni, setSelectedUni] = useState<string>("");
  const [programOptions, setProgramOptions] = useState<any[]>([]);
  const [selectedProgram, setSelectedProgram] = useState<string>("");
  const [selectedProgId, setSelectedProgId] = useState<string>("");

  useEffect(() => {
    axios
      .get("/university")
      .then((res) => {
        const list = res.data.universities.map((v: any) => ({
          label: v.name,
          value: v.short_name,
        }));
        setUniversityOption(list);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!selectedUni) return;

    axios
      .get(`/university?university_code=${selectedUni}`)
      .then((res) => {
        const list = res.data.universities[0].program.map((p: any) => ({
          label: p.short_name,
          value: p.short_name,
        }));
        setProgramOptions(list);
      })
      .catch(() => {});
  }, [selectedUni]);

  // useEffect(() => {
  //   const storedProgram = localStorage.getItem("selectedProgram");
  //   if (storedProgram) {
  //     // If program already selected, skip modal
  //     setSelectedProgram(storedProgram);
  //     setOpen(false);
  //     onSelect(storedProgram);
  //   }
  // }, []);

  // const handleSelect = () => {
  //   localStorage.setItem("selectedProgram", selectedProgram);
  //   onSelect(selectedProgram);
  //   setOpen(false);
  // };

  const handleSelect = () => {
    localStorage.setItem("selectedProgram", selectedProgram);
    localStorage.setItem("selectedProgId", selectedProgId);
    localStorage.setItem("university", selectedUni);
    localStorage.removeItem("selectedVersion");
    // fetchParent(selectedUni, selectedProgram);
    onSelect(selectedProgram);
    setOpen(false);
    window.location.pathname = "/curriculum/version";
  };

  return (
    <Modal
      isOpen={isOpen}
      setOpen={setOpen}
      customStyle={{
        overlay: { zIndex: "999999" },
        content: { marginTop: "10%", minWidth: "500px", padding: 20 },
      }}
    >
      <Title>
        <Icon>account_balance</Icon>
        Select University & Program
      </Title>

      <div style={{ paddingTop: 20, fontSize: 14, color: "#575757" }}>
        University:
      </div>
      <MinimalSelect
        isClearable={false}
        onChange={(item: any) => {
          setSelectedUni(item.value);
          setSelectedProgram("");
        }}
        name="university"
        options={universityOption}
        styles={{
          container: (base) => ({ ...base, minWidth: "100%" }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />

      <div style={{ paddingTop: 10, fontSize: 14, color: "#575757" }}>
        Program:
      </div>

      <MinimalSelect
        isClearable={false}
        onChange={(item: any) => {
          setSelectedProgram(item.value);
          setSelectedProgId(item.id);
        }}
        name="program"
        options={programOptions}
        isDisabled={!selectedUni}
        styles={{
          container: (base) => ({ ...base, minWidth: "100%" }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        value={programOptions.find((p: any) => p.value === selectedProgram)}
      />

      <FlexBox justify="end" style={{ paddingTop: 30 }}>
        <Button
          className="reduce_opct_onhover"
          onClick={() => {
            setOpen(false);
            setSelectedProgram("");
            setSelectedProgId("");
            setSelectedUni("");
          }}
          style={{
            border: "2px solid #64748B",
            padding: "8px 40px",
            fontSize: "14px",
          }}
        >
          Cancel
        </Button>
        <Button
          className="reduce_opct_onhover"
          onClick={handleSelect}
          disabled={!selectedProgram}
          style={{
            // width: 120,
            whiteSpace: "nowrap",
            background: theme.color.blueButton,
            color: "white",
            boxShadow: "0 2px 5px #808080cc",
            border: "none",
            gap: 10,
          }}
        >
          Change Program
          <Icon fontSize="small">start</Icon>
        </Button>
      </FlexBox>
    </Modal>
  );
};
